import React from 'react';
import { useIsChain } from '@utils/useIsChain';
import { NavigationCell } from '../NavigationCell';

const MenuCategories = ({ row }) => {
	const isChain = useIsChain();
	return (
		<NavigationCell barcode={row.barcode}>{isChain ? row.main_delivery_category : row.delivery_categories?.join(', ')}</NavigationCell>
	);
};

export { MenuCategories };
